// import { Upload, message, Modal } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
// import { useState } from "react";
// import './image.css';
// export default function NewsImageUploader({ images, setImages }) {
//   const [fileList, setFileList] = useState([]);
//   const [previewVisible, setPreviewVisible] = useState(false);
//   const [previewImage, setPreviewImage] = useState("");
//   const [previewTitle, setPreviewTitle] = useState("");

//   const beforeUpload = (file) => {
//     const isImage = file.type.startsWith("image/");
//     if (!isImage) {
//       message.error("Faqat rasm fayllari qabul qilinadi!");
//       return false;
//     }
//     return true;
//   };

//   const handleChange = ({ fileList: newFileList }) => {
//     setFileList(newFileList);

//     const newImages = newFileList.map((file) => {
//       return file.originFileObj || file.url; // For existing or new files
//     });

//     setImages(newImages);
//   };

//   const handlePreview = async (file) => {
//     const src = file.url || (await getBase64(file.originFileObj));
//     setPreviewImage(src);
//     setPreviewVisible(true);
//     setPreviewTitle(file.name || "Rasm");
//   };

//   const getBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = (error) => reject(error);
//     });
//   };

//   return (
//     <div style={{ textAlign: "center" }}>
//   <Upload
//   listType="picture-card"
//   fileList={fileList}
//   beforeUpload={beforeUpload}
//   onChange={handleChange}
//   onPreview={handlePreview} // custom preview
//   accept="image/*"
//   multiple
// >
//         {fileList.length >= 8 ? null : (
//           <div>
//             <PlusOutlined />
//             <div style={{ marginTop: 8 }}>Rasm yuklash</div>
//           </div>
//         )}
//       </Upload>

//       <Modal
//         visible={previewVisible}
//         title={previewTitle}
//         footer={null}
//         onCancel={() => setPreviewVisible(false)}
//       >
//         <img alt="preview" style={{ width: "100%" }} src={previewImage} />
//       </Modal>
//     </div>
//   );
// }


import { Upload, message, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import './image.css';

export default function NewsImageUploader({ images, setImages, resetTrigger }) {
  const [fileList, setFileList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  useEffect(() => {
    setFileList([]);
  }, [resetTrigger]);

  useEffect(() => {
    return () => {
      fileList.forEach(file => {
        if (file.url && file.url.startsWith('blob:')) {
          URL.revokeObjectURL(file.url);
        }
      });
    };
  }, [fileList]);

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Faqat rasm fayllari qabul qilinadi!");
      return false;
    }
    return true;
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);

    const newImages = newFileList.map((file) => {
      return file.originFileObj || file.url;
    });

    setImages(newImages);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.originFileObj) {
      return;
    }

    const src = file.url || (await getBase64(file.originFileObj));
    setPreviewImage(src);
    setPreviewVisible(true);
    setPreviewTitle(file.name || "Rasm");
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <div style={{ textAlign: "center" }}>
      <Upload
        listType="picture-card"
        fileList={fileList}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        onPreview={handlePreview}
        accept="image/*"
        multiple
      >
        {fileList.length >= 8 ? null : (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Rasm yuklash</div>
          </div>
        )}
      </Upload>

      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
}